<template>
  <AppSelect v-model:menu="menu" multiple>
    <template #prepend-item>
      <div class="sticky">
        <AppBtn size="small" primary @click="menu = false">
          {{ $tt('close') }}
        </AppBtn>
      </div>
    </template>
  </AppSelect>
</template>

<script setup lang="ts">
const menu = ref(false);
</script>

<style scoped>
.sticky {
  position: sticky;
  top: 0;
  height: 0;
  padding: 0 var(--space-2);
  display: flex;
  justify-content: flex-end;
  z-index: 1;
}
.sticky button {
  background-color: #fff;
}
</style>